import {Component, Input, OnInit, ViewEncapsulation} from '@angular/core';
import {AuditMixin} from "../../../_models/audit-mixin";
import {PopupService} from "../../../services/popup-service";
import {AuditMixinComponent} from "../audit-mixin.component";

@Component({
    selector: 'audit-mixin-indicator',
    templateUrl: './audit-mixin-indicator.component.html',
    styleUrls: ['./audit-mixin-indicator.component.less'],
    encapsulation: ViewEncapsulation.None
})
export class AuditMixinIndicatorComponent implements OnInit {
    @Input() model: AuditMixin & { id: string | number; type: string };
    @Input() showTitle = false;

    constructor(private popupService: PopupService) {
    }

    ngOnInit(): void {
    }

    openModal(event: any) {
        // Preserve the pre-PopupService contract: CustomDialogService.openCustomDialog
        // stopped propagation before opening, so callers (e.g. clickable table rows
        // that toggle expansion) didn't double-fire. PopupService.open doesn't.
        event?.stopPropagation();
        this.popupService.open(AuditMixinComponent, {
            x: event.clientX,
            y: event.clientY,
            panelClass: 'audit-mixin-dialog',
            draggable: true,
            inputs: {model: this.model as any, showTitle: this.showTitle}
        });
    }
}
